import React from 'react'
import { useShippingRateAction } from '../hooks/useCheckoutAction'
import { BusyButton } from '@ztechapps/webui.button'
import { Icon } from '@ztechapps/webui.util'
import { isInsuredAmountAcknowledgementGated } from '@ztechapps/order.common'
import { useCheckoutContext } from '../index'

export const ShippingRateButton = () => {
  const [onClickShippingRate] = useShippingRateAction()
  const context = useCheckoutContext()
  const [showLoadingOverlay] = context.showLoadingOverlay
  const [shippingOptions] = context.shippingOptions

  const isAcknowledgementGated = isInsuredAmountAcknowledgementGated(
    shippingOptions?.insuredAmount,
    shippingOptions?.gross,
    shippingOptions?.hasAcknowledgedLowInsuredAmount
  )

  return (
    <BusyButton
      disabled={showLoadingOverlay || isAcknowledgementGated}
      onClick={onClickShippingRate}
      text="Choose Shipping Rate"
    >
      <Icon name="chevron-right" />
    </BusyButton>
  )
}
